import React from 'react';

/**
 * The BrandScience mark and wordmark.
 *
 * Extracted from ModernAuthLayout, where it was defined inline, so the sign-in
 * page and the concierge offer screen cannot drift apart. Flat fills, never
 * gradients — that is the house rule for the orbital.
 */
export const BrandLogoIcon: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="24" cy="24" r="20" stroke="#3B82F6" strokeWidth="2" opacity="0.3" />
    <circle cx="24" cy="24" r="10" fill="#F59E0B" />
    <circle cx="24" cy="4" r="4" fill="#3B82F6" />
    <circle cx="6" cy="34" r="4" fill="#22C55E" />
    <circle cx="42" cy="34" r="4" fill="#3B82F6" />
  </svg>
);

/** Mark plus wordmark, horizontally centred. */
export const BrandLogo: React.FC<{
  size?: number;
  fontSize?: number;
  color?: string;
}> = ({ size = 48, fontSize = 24, color = '#1f2937' }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 12,
    }}
  >
    <BrandLogoIcon size={size} />
    <span style={{ fontSize, fontWeight: 700, color, letterSpacing: '-0.025em' }}>
      BrandScience<span style={{ color: '#94A3B8' }}>.ai</span>
    </span>
  </div>
);

export default BrandLogo;
